import { CheckBox } from 'devextreme-react/check-box';
import React, { FC } from 'react';
import { CheckBoxItem } from 'types';
import './checkbox-list.scss';

type Props = {
    data: CheckBoxItem[]
    onValueChanged: (selectedItem: string | number, isSelected: boolean) => void,
}

export const CheckboxList: FC<Props> = ({ data, onValueChanged }) => {

    return (
        <div className={'checkbox-list-card'}>
            {data.map(d =>
                <div className={'checkbox-list-row'} key={d.id}>
                    <CheckBox
                        value={d.isSelected}
                        disabled={!d.isEnable}
                        onValueChanged={(args) => { onValueChanged(d.id, args.value) }}
                    />
                    <div className={'checkbox-list-text'}>{d.text ?? d.id}</div>
                </div>
            )}
        </div>
    )
}